<script lang="ts">
  import AUPopover from "component_library/components/svelte/ui/AUPopover.svelte"
  import {
    getFloatingActionPlacement,
    type WidgetPosition,
  } from "website_script/lib/widgetPosition"
  import Prompt from "website_script/Prompt/Prompt.svelte"
  import WidgetPromptAction from "website_script/components/WidgetPromptAction.svelte"
  import type { PromptConfig } from "website_script/types/settings"
  import type { ButtonConfig } from "website_script/types/widgets"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import { getFlowsContext } from "website_script/contexts/flows"
  import { createEventDispatcher } from "svelte"

  export let widgetPosition: WidgetPosition
  export let promptConfig: PromptConfig
  export let buttonConfig: ButtonConfig
  export let integrationType: IntegrationTypes
  export let showArrow: boolean = true
  let popover: AUPopover
  export const getPopoverInstance = () => popover

  const { triggerFlow } = getFlowsContext()

  const placement = getFloatingActionPlacement(widgetPosition)
  const dispatch = createEventDispatcher()
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="popover-wrapper"
  on:click={() => {
    triggerFlow(buttonConfig, integrationType)
    popover.close()
  }}
  on:keydown={() => null}
>
  <AUPopover
    bind:this={popover}
    startOpened={true}
    fitToContent={buttonConfig.prompt_type === "simple"}
    {placement}
    {showArrow}
    ariaLabelledBy="au-prompt-title"
    ariaDescribedBy="au-prompt-description"
  >
    <Prompt
      onClose={(e) => {
        e.stopPropagation()
        popover.close()
        dispatch("close")
      }}
      type={buttonConfig.prompt_type}
    >
      <span slot="title" id="au-prompt-title">{promptConfig.title}</span>
      <span slot="description" id="au-prompt-description"
        >{promptConfig.description}</span
      >
      <WidgetPromptAction
        slot="action"
        {popover}
        {buttonConfig}
        {promptConfig}
        {integrationType}
      />
    </Prompt>
  </AUPopover>
</div>

<style>
  .popover-wrapper {
    display: contents;
    cursor: pointer;
  }
</style>
